
// Range slider input (used for Donations)
(function($) { "use strict";

	//Wait until everything is loaded
	window.addEventListener("load", function() {

		//force show the form if the user just submitted it. it contains either a success or a error message.
		const current_url_string = (window.location.href);
		const current_url = new URL(current_url_string);
		const formresponse = current_url.searchParams.get("formresponse");

		//if the user submitted the overlay, force open it on load to show the response
		if (formresponse === 'thankyou') {
			$('.mailing-list-overlay').removeClass('js-hidden');
			//set cookie to not automatically open the overlay again
			setCookie('mail_overlay_dismissed', true, 10 * 365 /* 10 years */);
		} else {
			//show overlay after 30 sec if it hasn't been dismissed before (and if it hasn't been just submitted. see above)
			const overlay_dismissed = getCookie('mail_overlay_dismissed');
			if (!overlay_dismissed) {
				setTimeout(function(){
					$('.mailing-list-overlay').removeClass('js-hidden');
				}, 5000 /* 5 seconds */);
			}
		}

		//manage overlay dismissal
		$('.mailing-list-overlay .close-button').on('click', function(){
			//hide overlay
			$('.mailing-list-overlay').addClass('js-hidden');

			//set cookie to not automatically open the overlay again
			setCookie('mail_overlay_dismissed', true, 10 * 365 /* 10 years */);
		});

	});

})(jQuery);

